/*
 * Copyright (c) 2004-2019 Paul Blacknell. All rights reserved.
 * https://github.com/blacknell
 */

import React, {Component, Fragment} from 'react';
import Moment from 'moment';
import 'moment/min/locales';
import axios from 'axios';
import ReactGA from 'react-ga';
import confirm from "reactstrap-confirm";

import Table from './Table';
import Settings from './Settings';
import Events from './classes/Events';
import sendClientEvent, {eventLevel} from './utils/sendClientEvent';

import {ButtonToolbar, Button} from 'reactstrap';
import {Alert, NavLink} from 'reactstrap';
import CalendarFooter from './CalendarFooter';
import Welcome from './Welcome';

const API_SETTINGS_PREFIX_REQUEST_PROD = '/api/v1/settings/';
const API_SETTINGS_PREFIX_REQUEST_LOCAL = 'http://api.sleepylizard.com/api.php?request=settings/';

const API_FORECAST_PREFIX_REQUEST_PROD = '/api/v1/weather/forecast/';
const API_FORECAST_PREFIX_REQUEST_LOCAL = 'http://api.sleepylizard.com/api.php?request=weather/forecast/';

const API_AUTHENTICATION_TOKEN = '4NUzB8CmVjzAvgP';

// Authorization scopes required by the API; multiple scopes can be included, separated by spaces.
// TODO Use https://www.googleapis.com/auth/calendar.readonly until we need to actually create and change a users calendars, and then use https://www.googleapis.com/auth/calendar
// We need calendar.readonly for adding/removing calendars in settings
// We need calendar.events to create and change appointments
const SCOPES = 'https://www.googleapis.com/auth/calendar.events https://www.googleapis.com/auth/calendar.readonly';
const CLIENT_ID = '1084547316944-camnso5qan3470ptpi0m79ptn8s4tq9j.apps.googleusercontent.com';
const API_KEY = 'AIzaSyAeM_-vKKr1FkO9mBFCaIb0RYBAGLvDU9Q';
const DISCOVERY_DOCS = ['https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest'];

const GA_TIMING_CATEGORY_RESTAPI = 'Sleepylizard API';
const GA_TIMING_CATEGORY_GOOGLE_API = 'Google API';

const CALENDAR_REFRESH_DELAY = 2000;

const PREFERENCES_IGNORE_GOOGLE_MEET = 'Hide Google Meet conference details';
const PREFERENCES_IGNORE_ZOOM_MEETING = 'Hide Zoom Meeting conference details';

var GoogleAuth;

class FamilyCalendar extends Component {

    constructor(props) {
        super(props);

        Moment.locale('en_GB');

        this.state = {

            signedIn: false,
            googleId: '',
            showCalendar: false,
            showWelcome: false,

            calendarDays: [],
            weekdays: [],
            events: [],
            observedDays: [],
            anniversaries: [],

            accessibleCalendars:[], // calendars this users has some access to

            startDay: Moment().startOf('week'),

            settingsModal: false,
            settingsDirty: false,    // used to enable/disable save button

            calendars: [],
            observedCalendars: [],
            anniversaryCalendars: [],

            // these are copies, used for editing inside the settings modal
            // after committing they replace calendars and observedCalendars
            settingsCalendars: [],
            settingsObservedCalendars:[],
            settingsAnniversaryCalendars: [],
            settingsIgnoreGoogleMeet: true,
            settingsIgnoreZoomMeeting: false,

            // weather forecast
            weather: [],

            // define user preference defaults
            ignoreGoogleMeet: true,
            ignoreZoomMeeting: false,

            //
            lastSuccessfulCalendarApiCall: 0,
        };

        this.handleClickCalendarJump = this.handleClickCalendarJump.bind(this);
        this.handleCreateAppt = this.handleCreateAppt.bind(this);
        this.handleUpdateEvent = this.handleUpdateEvent.bind(this);
        this.handleDeleteEvent = this.handleDeleteEvent.bind(this);

        this.loadCalendars = this.loadCalendars.bind(this);
        this.getAccessibleCalendars = this.getAccessibleCalendars.bind(this);
        this.updateSigninStatus = this.updateSigninStatus.bind(this);

        this.onOpenSettings = this.onOpenSettings.bind(this);
        this.onCancelSettings = this.onCancelSettings.bind(this);
        this.onSubmitSettings = this.onSubmitSettings.bind(this);

        this.onAddCalendarColumn = this.onAddCalendarColumn.bind(this);
        this.onChangeCalendar = this.onChangeCalendar.bind(this);
        this.onChangeCalendarDisplayName = this.onChangeCalendarDisplayName.bind(this);
        this.onDeleteCalendarColumn = this.onDeleteCalendarColumn.bind(this);

        this.onChangeObservedCalendar = this.onChangeObservedCalendar.bind(this);
        this.onAddObservedCalendar = this.onAddObservedCalendar.bind(this);
        this.onDeleteObservedCalendar = this.onDeleteObservedCalendar.bind(this);

        this.onChangeAnniversaryCalendar = this.onChangeAnniversaryCalendar.bind(this);
        this.onAddAnniversaryCalendar = this.onAddAnniversaryCalendar.bind(this);
        this.onDeleteAnniversaryCalendar = this.onDeleteAnniversaryCalendar.bind(this);

        this.onChangePreferences = this.onChangePreferences.bind(this);

        this.setupCalendar = this.setupCalendar.bind(this);
        this.clearEvents = this.clearEvents.bind(this);
        this.wait = this.wait.bind(this);

        this.componentDidMount = this.componentDidMount.bind(this);

        this.gapi=null;
    }

    async setupCalendar() {
        let user = GoogleAuth.currentUser.get();
        let googleEmail=user.getBasicProfile().getEmail();

        let profileSettings={};

        const now=performance.now();

        try {
            const restRequestPrefix = window.location.host === 'localhost:3000' ? API_SETTINGS_PREFIX_REQUEST_LOCAL : API_SETTINGS_PREFIX_REQUEST_PROD;
            const res = await axios.get(
                restRequestPrefix + googleEmail,
                {
                    timeout: 5000,
                    withCredentials: true,
                    headers: {'Authentication-Token': API_AUTHENTICATION_TOKEN},
                });

            ReactGA.timing({
                category: GA_TIMING_CATEGORY_RESTAPI,
                variable: 'settings.get',
                value: parseInt((performance.now() - now)), // in milliseconds
            });

            profileSettings = res.data;
            this.getAccessibleCalendars();  // accessible calendars as returned by the Google Calendar API
            this.setState({showCalendar: true});   // unhide the calendar

        } catch (error) {
            this.setState({showWelcome: true});
            if (typeof error.response !== 'undefined') {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx

                ReactGA.event({
                    category: 'Errors',
                    action: 'settings.get',
                    label: `Response - ${error.response.data.code} - ${error.response.data.error}`,
                    nonInteraction: true,
                });
                switch (error.response.status) {
                    case 403: {
                        await confirm(
                            {
                                title: 'Access Denied',
                                message: (
                                    <Fragment>Although you successfully signed in with your Google ID, access to sleepylizard was denied. Here is the error message.
                                        <Alert className='mt-2 mb-2' color='danger'>{error.response.status} - {error.response.data.code} - {error.response.data.error}</Alert>
                                        Please contact <NavLink className="inlineLink" href='mailto:support@sleepylizard.com'>support@sleepylizard.com</NavLink> if this continues
                                        to be a problem.
                                    </Fragment>
                                ),
                                confirmColor: 'primary',
                                cancelText: null,
                            },
                        );
                        break;
                    }
                    default:
                        console.warn(error.response.data);
                        console.warn(error.response.status);
                        console.warn(error.response.headers);
                    // eslint-disable-next-line no-fallthrough
                    case 503: {
                        await confirm(
                            {
                                title: 'Something went wrong at our end',
                                message: (
                                    <Fragment>Although you successfully signed in with your Google ID, access to sleepylizard failed. Here is the error message.
                                        <Alert className='mt-2 mb-2' color='danger'>{error.response.status} - {error.response.data.code} - {error.response.data.error}</Alert>
                                        Please contact <NavLink className="inlineLink" href='mailto:support@sleepylizard.com'>support@sleepylizard.com</NavLink> if this continues
                                        to be a problem.
                                    </Fragment>
                                ),
                                confirmColor: 'primary',
                                cancelText: null,
                            },
                        );
                        break;
                    }
                }
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.error(error.request);

                ReactGA.event({
                    category: 'Errors',
                    action: 'settings.get',
                    label: `Request - ${error.message}`,
                    nonInteraction: true,
                });
                await confirm(
                    {
                        title: 'Something went wrong at our end',
                        message: (
                            <Fragment>Although you successfully signed in with your Google ID, access to sleepylizard failed. Here is the error message.
                                <Alert className='mt-2 mb-2' color='danger'>Request - {error.message}</Alert>
                                Please contact <NavLink className="inlineLink" href='mailto:support@sleepylizard.com'>support@sleepylizard.com</NavLink> if this continues
                                to be a problem.
                            </Fragment>
                        ),
                        confirmColor: 'primary',
                        cancelText: null,
                    },
                );
            } else {
                // Something happened in setting up the request that triggered an Error
                console.error('Error', error.message);
                ReactGA.event({
                    category: 'Errors',
                    action: 'settings.get',
                    label: `Error - ${error.message}`,
                    nonInteraction: true,
                });
                await confirm(
                    {
                        title: 'Something went wrong at our end',
                        message: (
                            <Fragment>Although you successfully signed in with your Google ID, access to sleepylizard failed. Here is the error message.
                                <Alert className='mt-2 mb-2' color='danger'>Error - {error.message}</Alert>
                                Please contact <NavLink className="inlineLink" href='mailto:support@sleepylizard.com'>support@sleepylizard.com</NavLink> if this continues
                                to be a problem.
                            </Fragment>
                        ),
                        confirmColor: 'primary',
                        cancelText: null,
                    },
                );

            }
            profileSettings = {
                calendars: [],
                observedCalendars: [],
                anniversaryCalendars: [],
                user: googleEmail,
                gaUserId: '',
            };
        }

        let _events = new Array(profileSettings.calendars.length);
        _events.fill(null);
        for (let person = 0; person < profileSettings.calendars.length; person++) {
            _events[person] = new Events({
                column: person,
                events: [],
            });
        }

        let _calendarDays = new Array(7);
        _calendarDays.fill(null);
        for (let dow = 0; dow <= 6; dow++) {
            _calendarDays[dow] = Moment();
            _calendarDays[dow].add(dow, 'd');
        }

        let _weekdays = new Array(7);
        for (let dow = 0; dow <= 6; dow++) {
            _weekdays[dow] = new Array(profileSettings.calendars.length);
            _weekdays[dow].fill(null);
            for (let person = 0; person < profileSettings.calendars; person++) {
                _weekdays[dow][person] = [];
            }
        }

        ReactGA.set({ userId: profileSettings.gaUserId });
        this.setState({calendars: profileSettings.calendars});
        this.setState({settingsCalendars: profileSettings.calendars});
        this.setState({observedCalendars: profileSettings.observedCalendars});
        this.setState({settingsObservedCalendars:  profileSettings.observedCalendars});
        this.setState({anniversaryCalendars: profileSettings.anniversaryCalendars});
        this.setState({settingsAnniversaryCalendars:  profileSettings.anniversaryCalendars});

        // only override default preferences if they have been explicitly set
        let _profileSettings = typeof (profileSettings.userSettings) === 'undefined' ? [] : JSON.parse(JSON.stringify(profileSettings.userSettings));
        if (typeof (_profileSettings[0]) !== 'undefined' && typeof (_profileSettings[0].conferencing) !== 'undefined') {
            if (typeof (_profileSettings[0].conferencing.ignoreGoogleMeet) !== 'undefined') {
                this.setState({ignoreGoogleMeet: _profileSettings[0].conferencing.ignoreGoogleMeet});
            }
            if (typeof (_profileSettings[0].conferencing.ignoreZoomMeeting) !== 'undefined') {
                this.setState({ignoreZoomMeeting: _profileSettings[0].conferencing.ignoreZoomMeeting});
            }
        }

        // if we got lat/long then go find the weather forecast
        if (typeof profileSettings.location !== 'undefined') {
            const restForecastPrefix = window.location.host === 'localhost:3000' ? API_FORECAST_PREFIX_REQUEST_LOCAL : API_FORECAST_PREFIX_REQUEST_PROD;
            axios.get(
                restForecastPrefix + `/${profileSettings.location.latitude},${profileSettings.location.longitude}`,
                {
                    timeout: 5000,
                    withCredentials: true,
                    headers: {'Authentication-Token': API_AUTHENTICATION_TOKEN},
                }).then(function(response) {
                // add a moment for each daily forecast
                for (let i = 0; response.data.daily && i < response.data.daily.data.length; i++) {
                    response.data.daily.data[i]['date'] = Moment.unix(response.data.daily.data[i].time);
                }
                this.setState({weather: response.data});
            }.bind(this));
        }

        this.setState({events: _events});
        this.setState({calendarDays: _calendarDays});
        this.setState({weekdays: _weekdays});

        this.loadCalendars(Moment().startOf('week'));
    }

    updateSigninStatus(isSignedIn) {
        console.log("change of sign in status "+isSignedIn);
        this.setSigninStatus();

        ReactGA.event({
            category: 'Authentication',
            action: isSignedIn ? 'Sign In' : 'Sign Out',
        });

        if(isSignedIn) {
            this.setupCalendar();
            this.setState({showWelcome: false});
        } else {
            this.setState({calendars: []});
            this.setState({settingsCalendars: []});
            this.setState({observedCalendars: []});
            this.setState({settingsObservedCalendars:  []});

            this.setState({events: []});
            this.setState({calendarDays: []});
            this.setState({weekdays: []});
            this.setState({showWelcome: true});
        }
    }

    setSigninStatus() {
        var user = GoogleAuth.currentUser.get();
        var isAuthorized = user.hasGrantedScopes(SCOPES);
        if (isAuthorized) {
            let googleEmail = user.getBasicProfile().getEmail();
            this.setState({signedIn: true});
            this.setState({googleId: googleEmail});
        } else {
            this.setState({signedIn: false});
            this.setState({googleId: ''});
        }
    }

    componentDidMount() {

        require('google-client-api')().then((gapi) => {

            this.gapi = gapi;

            let now=performance.now();
            gapi.client.init({
                apiKey: API_KEY,
                discoveryDocs: DISCOVERY_DOCS,
                clientId: CLIENT_ID,
                scope: SCOPES,
            }).then(async function() {
                ReactGA.timing({
                    category: GA_TIMING_CATEGORY_GOOGLE_API,
                    variable: 'init',
                    value: parseInt((performance.now()-now)), // in milliseconds
                });

                GoogleAuth = gapi.auth2.getAuthInstance();
                GoogleAuth.isSignedIn.listen(this.updateSigninStatus);

                this.setSigninStatus();

                if (!GoogleAuth.isSignedIn.get()) {
                    console.warn('User is not signed in');
                    this.setState({showWelcome: true});
                } else {
                    this.setState({lastSuccessfulCalendarApiCall: Moment()})
                    this.setupCalendar();
                }

            }.bind(this), async function(error) {
                console.error(error);
                await confirm(
                    {
                        title: 'Something went wrong',
                        message: (
                            <Fragment>There was an error when trying to initialise. Please try again later.<br/><br/>
                                <Alert color='info'>Error message '{error.details}'</Alert>
                            </Fragment>
                        ),
                        confirmColor: 'primary',
                        cancelText: null,
                    },
                );
            });  // end of callback having initialised google api
        });

    }

    handleClickCalendarJump = (startDay) => (e) => {

        ReactGA.event({
            category: 'Navigation',
            action: 'Jump',
            label: Moment(startDay).isSame(Moment(), 'day') ?
                'Today' :
                Moment(startDay).diff(this.state.startDay, 'weeks') > 0 ? 'Forward' : 'Back',
            value: Moment(startDay).diff(this.state.startDay, 'weeks'),
        });

        this.clearEvents();
        this.loadCalendars(startDay.startOf('week'));
    };

    clearEvents() {

        // clear all the events from the current display
        let events = new Array(this.state.calendars.length);
        events.fill(null);
        for (let person = 0; person < this.state.calendars.length; person++) {
            events[person] = new Events({
                column: person,
                events: [],
            });
        }
        this.setState({events});

    }

    wait(ms) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(ms);
            }, ms);
        });
    }

    handleCreateAppt(event) {

        let now=performance.now();
        this.gapi.client.calendar.events.insert({
            calendarId: event.organizer.email,
            resource: event,
            sendUpdates: 'externalOnly',
        }).then(async function(response) {
            console.log(response);
            ReactGA.timing({
                category: GA_TIMING_CATEGORY_GOOGLE_API,
                variable: 'calendar.events.insert',
                value: parseInt((performance.now()-now)), // in milliseconds
            });
            this.setState({lastSuccessfulCalendarApiCall: Moment()})

            // force a synchronous wait so that the delay in updating other calendars (than the owner)
            // comes through on the load calendars call
            // TODO replace this with calendar api push noticifications
            await this.wait(CALENDAR_REFRESH_DELAY);

            this.clearEvents();
            this.loadCalendars(this.state.startDay.clone().startOf('week'));
        }.bind(this), async function(error) {
            console.error(error.result);
            ReactGA.event({
                category: 'Errors',
                action: 'calendar.events.insert',
                label: `${error.result.error.message} - ${error.result.error.code}`,
                nonInteraction: true,
            });

            // send the error to the logger
            const user = GoogleAuth.currentUser.get();
            const googleEmail = user.getBasicProfile().getEmail();

            sendClientEvent(eventLevel.error, 'calendar.events.insert', {
                googleEmail: googleEmail,
                event: event,
                error: error,
                lastSuccess: {
                    timestamp: this.state.lastSuccessfulCalendarApiCall.toISOString(),
                    durationMinutes: Moment.duration(this.state.lastSuccessfulCalendarApiCall.diff(Moment())).asMinutes()
                },
            });

            await confirm(
                {
                    title: 'Something went wrong',
                    message: (
                        <Fragment>There was an error when trying to save the appointment. Please try again later.<br/><br/>
                            <Alert color='info'>Error message '{error.result.error.message} - {error.result.error.code}'</Alert>
                        </Fragment>
                    ),
                    confirmColor: 'danger',
                    cancelText: null,
                },
            );
        });
    }

    handleUpdateEvent(event) {
        console.log(event);

        var now;
        if (event.eventResource.organizer.email === event.organizer.email) {
            //update
            now=performance.now();
            this.gapi.client.calendar.events.update({
                calendarId: event.eventResource.organizer.email,
                eventId: event.eventResource.id,
                resource: event.eventResource,
                sendUpdates: 'externalOnly',
            }).then(async function(response) {
                console.log(response.result);
                ReactGA.timing({
                    category: GA_TIMING_CATEGORY_GOOGLE_API,
                    variable: 'calendar.events.update',
                    value: parseInt((performance.now() - now)), // in milliseconds
                });
                this.setState({lastSuccessfulCalendarApiCall: Moment()})

                // force a synchronous wait so that the delay in updating other calendars (than the owner)
                // comes through on the load calendars call
                // TODO replace this with calendar api push noticifications
                await this.wait(CALENDAR_REFRESH_DELAY);

                this.clearEvents();
                this.loadCalendars(this.state.startDay.clone().startOf('week'));
            }.bind(this), async function(error) {
                console.error(error);
                ReactGA.event({
                    category: 'Errors',
                    action: 'calendar.events.update',
                    label: `1 ${error.result.error.message} - ${error.result.error.code}`,
                    nonInteraction: true,
                });

                // send the error to the logger
                const user = GoogleAuth.currentUser.get();
                const googleEmail = user.getBasicProfile().getEmail();
                sendClientEvent(eventLevel.error, 'calendar.events.update.1', {
                    googleEmail: googleEmail, event: event, error: error, lastSuccess: {
                        timestamp: this.state.lastSuccessfulCalendarApiCall.toISOString(),
                        durationMinutes: Moment.duration(this.state.lastSuccessfulCalendarApiCall.diff(Moment())).asMinutes()
                    },
                });

                await confirm(
                    {
                        title: 'Something went wrong',
                        message: (
                            <Fragment>There was an error when trying to save the appointment. Please try again later.<br/><br/>
                                <Alert color='info'>Error message '{error.result.error.message} - {error.result.error.code}'</Alert>
                            </Fragment>
                        ),
                        confirmColor: 'danger',
                        cancelText: null,
                    },
                );
            });
        } else {
            // move followed by update
            now=performance.now();
            this.gapi.client.calendar.events.move({
                calendarId: event.eventResource.organizer.email,
                eventId: event.eventResource.id,
                destination: event.organizer.email,
                sendUpdates: 'externalOnly',
            }).then(async function(response) {
                console.log(response.result);
                ReactGA.timing({
                    category: GA_TIMING_CATEGORY_GOOGLE_API,
                    variable: 'calendar.events.move',
                    value: parseInt((performance.now() - now)), // in milliseconds
                });
                this.setState({lastSuccessfulCalendarApiCall: Moment()})

                now=performance.now();
                this.gapi.client.calendar.events.update({
                    calendarId: event.organizer.email,
                    eventId: event.eventResource.id,
                    resource: event.eventResource,
                    sendUpdates: 'externalOnly',
                }).then(async function(response) {
                    console.log(response.result);
                    ReactGA.timing({
                        category: GA_TIMING_CATEGORY_GOOGLE_API,
                        variable: 'calendar.events.update',
                        value: parseInt((performance.now() - now)), // in milliseconds
                    });
                    this.setState({lastSuccessfulCalendarApiCall: Moment()})

                    // force a synchronous wait so that the delay in updating other calendars (than the owner)
                    // comes through on the load calendars call
                    // TODO replace this with calendar api push noticifications
                    await this.wait(CALENDAR_REFRESH_DELAY);

                    this.clearEvents();
                    this.loadCalendars(this.state.startDay.clone().startOf('week'));
                }.bind(this), async function(error) {
                    console.error(error);
                    ReactGA.event({
                        category: 'Errors',
                        action: 'calendar.events.update',
                        label: `2 ${error.result.error.message} - ${error.result.error.code}`,
                        nonInteraction: true,
                    });

                    // send the error to the logger
                    const user = GoogleAuth.currentUser.get();
                    const googleEmail = user.getBasicProfile().getEmail();
                    sendClientEvent(eventLevel.error, 'calendar.events.update.2', {
                        googleEmail: googleEmail, event: event, error: error, lastSuccess: {
                            timestamp: this.state.lastSuccessfulCalendarApiCall.toISOString(),
                            durationMinutes: Moment.duration(this.state.lastSuccessfulCalendarApiCall.diff(Moment())).asMinutes()
                        },
                    });

                    await confirm(
                        {
                            title: 'Something went wrong',
                            message: (
                                <Fragment>There was an error when trying to save the appointment. Please try again later.<br/><br/>
                                    <Alert color='info'>Error message '{error.result.error.message} - {error.result.error.code}'</Alert>
                                </Fragment>
                            ),
                            confirmColor: 'danger',
                            cancelText: null,
                        },
                    );
                });

                // force a synchronous wait so that the delay in updating other calendars (than the owner)
                // comes through on the load calendars call
                // TODO replace this with calendar api push noticifications
                await this.wait(CALENDAR_REFRESH_DELAY);

                this.clearEvents();
                this.loadCalendars(this.state.startDay.clone().startOf('week'));
            }.bind(this), async function(error) {
                console.error(error);
                ReactGA.event({
                    category: 'Errors',
                    action: 'calendar.events.move',
                    label: `${error.result.error.message} - ${error.result.error.code}`,
                    nonInteraction: true,
                });

                // send the error to the logger
                const user = GoogleAuth.currentUser.get();
                const googleEmail = user.getBasicProfile().getEmail();
                sendClientEvent(eventLevel.error, 'calendar.events.move', {
                    googleEmail: googleEmail, event: event, error: error, lastSuccess: {
                        timestamp: this.state.lastSuccessfulCalendarApiCall.toISOString(),
                        durationMinutes: Moment.duration(this.state.lastSuccessfulCalendarApiCall.diff(Moment())).asMinutes()
                    },
                });

                await confirm(
                    {
                        title: 'Something went wrong',
                        message: (
                            <Fragment>There was an error when trying to save the appointment. Please try again later.<br/><br/>
                                <Alert color='info'>Error message '{error.result.error.message} - {error.result.error.code}'</Alert>
                            </Fragment>
                        ),
                        confirmColor: 'danger',
                        cancelText: null,
                    },
                );
            });
        }

    }

    handleDeleteEvent(event) {
        console.log(event);

        ReactGA.event({
            category: 'Appointment',
            action: 'Delete',
        });

        let now=performance.now();
        this.gapi.client.calendar.events.delete({
            calendarId: event.organizer.email,
            eventId: event.id,
            sendUpdates: 'externalOnly',
        }).then(async function(response) {
            ReactGA.timing({
                category: GA_TIMING_CATEGORY_GOOGLE_API,
                variable: 'calendar.events.delete',
                value: parseInt((performance.now() - now)), // in milliseconds
            });
            console.log(response);
            this.setState({lastSuccessfulCalendarApiCall: Moment()})

            // force a synchronous wait so that the delay in updating other calendars (than the owner)
            // comes through on the load calendars call
            // TODO replace this with calendar api push notifications
            await this.wait(CALENDAR_REFRESH_DELAY);

            this.clearEvents();
            this.loadCalendars(this.state.startDay.clone().startOf('week'));
        }.bind(this), async function(error) {
            ReactGA.event({
                category: 'Errors',
                action: 'calendar.events.delete',
                label: `${error.result.error.message} - ${error.result.error.code}`,
                nonInteraction: true,
            });

            // send the error to the logger
            const user = GoogleAuth.currentUser.get();
            const googleEmail = user.getBasicProfile().getEmail();
            sendClientEvent(eventLevel.error, 'calendar.events.delete', {
                googleEmail: googleEmail, event: event, error: error, lastSuccess: {
                    timestamp: this.state.lastSuccessfulCalendarApiCall.toISOString(),
                    durationMinutes: Moment.duration(this.state.lastSuccessfulCalendarApiCall.diff(Moment())).asMinutes()
                },
            });

            await confirm(
                {
                    title: 'Something went wrong',
                    message: (
                        <Fragment>There was an error when trying to delete the appointment. Please try again later.<br/><br/>
                            <Alert color='info'>Error message '{error.result.error.message} - {error.result.error.code}'</Alert>
                        </Fragment>
                    ),
                    confirmColor: 'danger',
                    cancelText: null,
                },
            );
            console.error(error);
        });
    }

    getAccessibleCalendars() {
        let now = performance.now();
        this.gapi.client.calendar.calendarList.list({
            'minAccessRole': 'freeBusyReader',
            'maxResults': 100,
        }).then(response => {
            ReactGA.timing({
                category: GA_TIMING_CATEGORY_GOOGLE_API,
                variable: 'calendar.calendarList.list',
                value: parseInt((performance.now() - now)), // in milliseconds
            });
            console.log(response.result.items);
            this.setState({lastSuccessfulCalendarApiCall: Moment()})

            // sort the calendars alphabetically
            let _gc = response.result.items;
            _gc.sort(function(a, b) {
                const aSummary = a.summaryOverride && a.summaryOverride.length > 0 ? a.summaryOverride : a.summary;
                const bSummary = b.summaryOverride && b.summaryOverride.length > 0 ? b.summaryOverride : b.summary;
                return aSummary.localeCompare(bSummary);
            });

            let _calendars = JSON.parse(JSON.stringify(this.state.calendars));
            let isCalendarProfileListEmpty = _calendars.length === 0;
            // do we have any calendars listed in the profile
            const user = GoogleAuth.currentUser.get();
            const thisUsersGoogleId = user.getBasicProfile().getEmail();

            if (isCalendarProfileListEmpty) {
                let cal = _gc.find(({id}) => thisUsersGoogleId === id);
                isCalendarProfileListEmpty = true;
                _calendars.push({
                    column: 1,
                    calendarId: cal.id,
                    accessRole: cal.accessRole,
                    displayName: cal.summary,
                });
            }

            // update the calendar metadata with latest from google calendar
            for (let cal = 0; cal < _calendars.length; cal++) {
                for (let acc = 0; acc < _gc.length; acc++) {
                    if (_calendars[cal].calendarId === _gc[acc].id) {
                        _calendars[cal].accessRole = _gc[acc].accessRole;
                        break;
                    }
                }
            }

            // do the same for settingsCalendar
            let _settings = JSON.parse(JSON.stringify(this.state.settingsCalendars));
            if (isCalendarProfileListEmpty) {
                let cal = _gc.find(({id}) => thisUsersGoogleId === id);
                _settings.push({
                    column: 1,
                    calendarId: cal.id,
                    accessRole: cal.accessRole,
                    displayName: cal.summary,
                });
            }

            for (let cal = 0; cal < _settings.length; cal++) {
                for (let acc = 0; acc < _gc.length; acc++) {
                    if (_settings[cal].calendarId === _gc[acc].id) {
                        _settings[cal].accessRole = _gc[acc].accessRole;
                        break;
                    }
                }
            }

            if (isCalendarProfileListEmpty) {
                this.onOpenSettings(true);
            }

            this.setState({accessibleCalendars: _gc});
            this.setState({calendars: _calendars});
            this.setState({settingsCalendars: _settings});

        }).catch(function(error) {
            ReactGA.event({
                category: 'Errors',
                action: 'calendar.calendarList.list',
                nonInteraction: true,
            });
            console.warn(error);

            // send the error to the logger
            const user = GoogleAuth.currentUser.get();
            const googleEmail = user.getBasicProfile().getEmail();
            sendClientEvent(eventLevel.error, 'calendar.calendarList.list', {
                googleEmail: googleEmail, error: error, lastSuccess: {
                    timestamp: this.state.lastSuccessfulCalendarApiCall.toISOString(),
                    durationMinutes: Moment.duration(this.state.lastSuccessfulCalendarApiCall.diff(Moment())).asMinutes()
                },
            });
        });

    }

    loadCalendars(startDay) {
        let calendars = this.state.calendars;

        this.setState({startDay});
        // first let's set the current week
        let day1 = startDay.clone().startOf('week');
        let day7 = startDay.clone().endOf('week');

        let calendarDays = new Array(7);
        calendarDays.fill(null);
        for (let dow = 0; dow <= 6; dow++) {
            calendarDays[dow] = Moment(startDay); // cloned
            calendarDays[dow].add(dow, 'd');
        }
        this.setState({calendarDays});

        // now let's go and get the events in the calendar
        for (let i = 0; i < calendars.length; i++) { // for the first person
            let now=performance.now();
            this.gapi.client.calendar.events.list({
                'calendarId': calendars[i].calendarId,
                'timeMin': day1.toISOString(),
                'timeMax': day7.toISOString(),
                'showDeleted': false,
                'singleEvents': true,
                'orderBy': 'startTime',
            }).then(function(response) {
                ReactGA.timing({
                    category: GA_TIMING_CATEGORY_GOOGLE_API,
                    variable: 'calendar.events.list',
                    value: parseInt((performance.now()-now)), // in milliseconds
                });
                console.log(response.result);
                this.setState({lastSuccessfulCalendarApiCall: Moment()})

                console.assert(calendars[i].column > 0);
                if (calendars[i].column > 0) {
                    calendars[calendars[i].column - 1].accessRole = response.result.accessRole;
                    if (response.result.items.length > 0) {
                        // update the state with this persons items
                        this.setEvents(calendars[i].column - 1, response.result.items, response.result.accessRole);
                    }
                }

            }.bind(this));  // end of callback having retrieved events for one of the calendars
        }

        var observedCalendars = this.state.observedCalendars;
        this.setState({observedDays: []});
        for (let j = 0; observedCalendars && j < observedCalendars.length; j++) {
            let now=performance.now();
            this.gapi.client.calendar.events.list({
                'calendarId': observedCalendars[j].calendarId,
                'timeMin': day1.toISOString(),
                'timeMax': day7.toISOString(),
                'showDeleted': false,
                'singleEvents': true,
                'orderBy': 'startTime',
            }).then(function(response) {
                ReactGA.timing({
                    category: GA_TIMING_CATEGORY_GOOGLE_API,
                    variable: 'calendar.events.list',
                    value: parseInt((performance.now()-now)), // in milliseconds
                });
                this.setState({lastSuccessfulCalendarApiCall: Moment()})

                // find the calendar end user name and add to the days
                // note on initial page load we might have these yet so fail cleanly
                const calendar = this.state.accessibleCalendars.find(({id}) => observedCalendars[j].calendarId === id);
                for (let i = 0; typeof calendar !== 'undefined' && i < response.result.items.length; i++) {
                    response.result.items[i]['calendarSummary'] = calendar.summaryOverride ? calendar.summaryOverride : calendar.summary;
                }
                let _obs = JSON.parse(JSON.stringify(this.state.observedDays)).concat(response.result.items);
                this.setState({observedDays: _obs});
            }.bind(this));
        }

        // now get the anniversary calendars
        var anniversaryCalendars = this.state.anniversaryCalendars;
        this.setState({anniversaries: []});
        for (let j = 0; anniversaryCalendars && j < anniversaryCalendars.length; j++) {
            let now=performance.now();
            this.gapi.client.calendar.events.list({
                'calendarId': anniversaryCalendars[j].calendarId,
                'timeMin': day1.toISOString(),
                'timeMax': day7.toISOString(),
                'showDeleted': false,
                'singleEvents': true,
                'orderBy': 'startTime',
            }).then(function(response) {
                ReactGA.timing({
                    category: GA_TIMING_CATEGORY_GOOGLE_API,
                    variable: 'calendar.events.list',
                    value: parseInt((performance.now()-now)), // in milliseconds
                });
                this.setState({lastSuccessfulCalendarApiCall: Moment()})

                for (let i = 0; i < response.result.items.length; i++) {
                    response.result.items[i]['associatedCalendarId'] = anniversaryCalendars[j].associatedCalendarId;
                }
                let anniversaries = JSON.parse(JSON.stringify(this.state.anniversaries)).concat(response.result.items);
                this.setState({anniversaries: anniversaries});
            }.bind(this));
        }
    }

    // because state members are immutable we have to copy and replace the whole object
    setEvents = (column, newEvents, accessRole) => {
        this.setState(state => {
            const events = state.events.map((item) => {
                if (item.column === column) {
                    return {
                        person: item.column,
                        accessRole: accessRole,
                        events: newEvents,
                    };
                } else {
                    return item;
                }
            });

            return {
                events,
            };
        });
    };

    onOpenSettings(forceDirty = false) {

        ReactGA.event({
            category: 'Settings',
            action: 'Open',
        });

        this.setState({
            settingsModal: true,
            settingsDirty: forceDirty,
        });

        this.setState({settingsIgnoreGoogleMeet: this.state.ignoreGoogleMeet})
        this.setState({settingsIgnoreZoomMeeting: this.state.ignoreZoomMeeting})
    }

    onCancelSettings() {

        // copy original calendars into settings calendars
        // we have to do a deep copy

        ReactGA.event({
            category: 'Settings',
            action: 'Cancel',
        });

        let _calendars = JSON.parse(JSON.stringify(this.state.calendars));
        this.setState({settingsCalendars: _calendars});

        let _observedCalendars = JSON.parse(JSON.stringify(this.state.observedCalendars));
        this.setState({settingsObservedCalendars: _observedCalendars});

        let _anniversaryCalendars = JSON.parse(JSON.stringify(this.state.anniversaryCalendars));
        this.setState({settingsAnniversaryCalendars: _anniversaryCalendars});

        this.setState({
            settingsModal: false,
            settingsDirty: false,
        });
    }

    async onSubmitSettings() {

        ReactGA.event({
            category: 'Settings',
            action: 'Save',
        });

        // copy settings calendars into calendars
        // we have to do a deep copy

        let _calendars = JSON.parse(JSON.stringify(this.state.settingsCalendars));
        this.setState({calendars: _calendars});

        let _observedCalendars = JSON.parse(JSON.stringify(this.state.settingsObservedCalendars));
        this.setState({observedCalendars: _observedCalendars});

        let _anniversaryCalendars = JSON.parse(JSON.stringify(this.state.settingsAnniversaryCalendars));
        this.setState({anniversaryCalendars: _anniversaryCalendars});

        this.setState({ignoreGoogleMeet: this.state.settingsIgnoreGoogleMeet})
        this.setState({ignoreZoomMeeting: this.state.settingsIgnoreZoomMeeting})

        // build the preference schema (using the dialog values)
        const preferences = [{
            "conferencing": {
                "ignoreGoogleMeet": this.state.settingsIgnoreGoogleMeet,
                "ignoreZoomMeeting": this.state.settingsIgnoreZoomMeeting
            },
        }]

        let user = GoogleAuth.currentUser.get();
        let googleEmail=user.getBasicProfile().getEmail();

        const now=performance.now();
        const restRequestPrefix = window.location.host === 'localhost:3000' ? API_SETTINGS_PREFIX_REQUEST_LOCAL : API_SETTINGS_PREFIX_REQUEST_PROD;
        await axios.put(
            restRequestPrefix+googleEmail,
            {
                calendars: this.state.settingsCalendars,
                observedCalendars: this.state.settingsObservedCalendars,
                anniversaryCalendars: this.state.settingsAnniversaryCalendars,
                userSettings: preferences,
            },
            {
                headers: {
                    'Accept': 'application/json',
                    'Authentication-Token': API_AUTHENTICATION_TOKEN,
                },
                withCredentials: true,
                timeout: 5000,

            }).then(res => {

            ReactGA.timing({
                category: GA_TIMING_CATEGORY_RESTAPI,
                variable: 'settings.put',
                value: parseInt((performance.now()-now)), // in milliseconds
            });

            this.clearEvents();
            this.loadCalendars(this.state.startDay.clone().startOf('week'));

        }).catch(async function(error) {
            if (typeof error.response !== 'undefined') {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx

                ReactGA.event({
                    category: 'Errors',
                    action: 'settings.put',
                    label: error.response.status,
                    nonInteraction: true,
                });

                await confirm(
                    {
                        title: 'Something went wrong at our end',
                        message: (
                            <Fragment>It was not possible to save your settings due to an internal error. Here is the error message.
                                <Alert className='mt-2 mb-2' color='danger'>{error.response.data.code} - {error.response.data.error}</Alert>
                                Please contact <NavLink className="inlineLink" href='mailto:support@sleepylizard.com'>support@sleepylizard.com</NavLink> if this continues
                                to be a problem.
                            </Fragment>
                        ),
                        confirmColor: 'primary',
                        cancelText: null,
                    },
                );

            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js

                ReactGA.event({
                    category: 'Errors',
                    action: 'settings.put',
                    label: `Request - ${error.message}`,
                    nonInteraction: true,
                });

                await confirm(
                    {
                        title: 'Something went wrong at our end',
                        message: (
                            <Fragment>It was not possible to save your settings due to an internal error. Here is the error message.
                                <Alert className='mt-2 mb-2' color='danger'>Request - {error.message}</Alert>
                                Please contact <NavLink className="inlineLink" href='mailto:support@sleepylizard.com'>support@sleepylizard.com</NavLink> if this continues
                                to be a problem.
                            </Fragment>
                        ),
                        confirmColor: 'primary',
                        cancelText: null,
                    },
                );

            } else {
                // Something happened in setting up the request that triggered an Error

                ReactGA.event({
                    category: 'Errors',
                    action: 'settings.put',
                    label: `Error - ${error.message}`,
                    nonInteraction: true,
                });

                await confirm(
                    {
                        title: 'Something went wrong at our end',
                        message: (
                            <Fragment>It was not possible to save your settings due to an internal error. Here is the error message.
                                <Alert className='mt-2 mb-2' color='danger'>Error - {error.message}</Alert>
                                Please contact <NavLink className="inlineLink" href='mailto:support@sleepylizard.com'>support@sleepylizard.com</NavLink> if this continues
                                to be a problem.
                            </Fragment>
                        ),
                        confirmColor: 'primary',
                        cancelText: null,
                    },
                );

            }
            console.log(error.config);
        });

        this.setState({
            settingsModal: false,
            settingsDirty: false,
        });
    }

    onAddObservedCalendar() {

        ReactGA.event({
            category: 'Settings',
            action: 'Add',
            label: 'Observed',
        });

        let defCalendar;
        for (let cal = 0; cal < this.state.accessibleCalendars.length; cal++) {
            if (this.state.accessibleCalendars[cal].id === this.state.googleId) {
                defCalendar = this.state.accessibleCalendars[cal];
            }
        }

        let _calendars = this.state.settingsObservedCalendars;
        _calendars.push(
            {
                calendarId: this.state.googleId,
                column: _calendars.length + 1,  // not zero indexed, and we haven't pushed it yet
                displayName: defCalendar.summaryOverride && defCalendar.summaryOverride.length > 0 ? defCalendar.summaryOverride : defCalendar.summary,
            },
        );
        console.log(_calendars);
        this.setState({settingsObservedCalendars: _calendars});
        this.setState({
            settingsDirty: true,
        });

    }

    onChangeObservedCalendar(column, value) {

        ReactGA.event({
            category: 'Settings',
            action: 'Change',
            label: 'Observed',
        });

        let _calendars = JSON.parse(JSON.stringify(this.state.observedCalendars));
        _calendars[column] =
            {
                calendarId: value,
                column: column+1,
            };

        this.setState({settingsObservedCalendars: _calendars});
        this.setState({
            settingsDirty: true,
        });
    }

    onDeleteObservedCalendar(column) {

        ReactGA.event({
            category: 'Settings',
            action: 'Remove',
            label: 'Observed',
        });

        // remove the array element that matches the column being removed
        let _calendars = JSON.parse(JSON.stringify(this.state.settingsObservedCalendars));
        for (let cal = 0; cal < _calendars.length; cal++) {
            if (_calendars[cal].column === column + 1) _calendars.splice(cal, 1);
        }

        // and re-balance the column numbers
        let _filtered = JSON.parse(JSON.stringify(_calendars));
        for (let cal = 0; cal < _filtered.length; cal++) {
            if (_filtered[cal].column > column + 1) _filtered[cal].column--;
        }

        this.setState({settingsObservedCalendars: _filtered});
        this.setState({
            settingsDirty: true,
        });
    }

    onAddAnniversaryCalendar() {

        ReactGA.event({
            category: 'Settings',
            action: 'Add',
            label: 'Anniversary',
        });

        let defCalendar;
        for (let cal = 0; cal < this.state.accessibleCalendars.length; cal++) {
            if (this.state.accessibleCalendars[cal].id === this.state.googleId) {
                defCalendar = this.state.accessibleCalendars[cal];
            }
        }

        let _calendars = this.state.settingsAnniversaryCalendars;
        _calendars.push(
            {
                calendarId: this.state.googleId,
                associatedCalendarId: this.state.googleId,
                column: _calendars.length + 1,  // not zero indexed, and we haven't pushed it yet
                displayName: defCalendar.summaryOverride && defCalendar.summaryOverride.length > 0 ? defCalendar.summaryOverride : defCalendar.summary,
            },
        );
        this.setState({settingsAnniversaryCalendars: _calendars});
        this.setState({
            settingsDirty: true,
        });

    }

    onChangeAnniversaryCalendar(column, value) {

        ReactGA.event({
            category: 'Settings',
            action: 'Change',
            label: 'Anniversary',
        });

        let _calendars = JSON.parse(JSON.stringify(this.state.settingsAnniversaryCalendars));
        _calendars[column] =
            {
                calendarId: value,
                associatedCalendarId: this.state.googleId,
                column: column+1,
            };

        this.setState({settingsAnniversaryCalendars: _calendars});
        this.setState({
            settingsDirty: true,
        });
    }

    onDeleteAnniversaryCalendar(column) {

        ReactGA.event({
            category: 'Settings',
            action: 'Remove',
            label: 'Anniversary',
        });

        // remove the array element that matches the column being removed
        let _calendars = JSON.parse(JSON.stringify(this.state.settingsAnniversaryCalendars));
        for (let cal = 0; cal < _calendars.length; cal++) {
            if (_calendars[cal].column === column + 1) _calendars.splice(cal, 1);
        }

        // and re-balance the column numbers
        let _filtered = JSON.parse(JSON.stringify(_calendars));
        for (let cal = 0; cal < _filtered.length; cal++) {
            if (_filtered[cal].column > column + 1) _filtered[cal].column--;
        }

        this.setState({settingsAnniversaryCalendars: _filtered});
        this.setState({
            settingsDirty: true,
        });
    }

    onAddCalendarColumn() {

        ReactGA.event({
            category: 'Settings',
            action: 'Add',
            label: 'Calendar',
        });

        const defaultCalendar = this.state.accessibleCalendars.find(({id}) => this.state.googleId === id);
        console.assert(typeof defaultCalendar !== 'undefined');

        let _calendars = this.state.settingsCalendars;
        _calendars.push(
            {
                calendarId: this.state.googleId,
                column: _calendars.length + 1,  // not zero indexed, and we haven't pushed it yet
                displayName: defaultCalendar && defaultCalendar.summaryOverride && defaultCalendar.summaryOverride.length > 0
                    ? defaultCalendar.summaryOverride
                    : typeof defaultCalendar !== 'undefined' ? defaultCalendar.summary : 'undefined',
            });
        this.setState({settingsCalendars: _calendars});
        this.setState({
            settingsDirty: true,
        });
    }

    onChangeCalendar(column, calendarId) {

        ReactGA.event({
            category: 'Settings',
            action: 'Change',
            label: 'Calendar',
        });

        let _calendars = JSON.parse(JSON.stringify(this.state.settingsCalendars));

        const defaultCalendar = this.state.accessibleCalendars.find(({id}) => calendarId === id);
        console.assert(typeof defaultCalendar !== 'undefined');

        _calendars[column] =
            {
                calendarId: calendarId,
                column: column+1,
                displayName: defaultCalendar && defaultCalendar.summaryOverride && defaultCalendar.summaryOverride.length > 0
                    ? defaultCalendar.summaryOverride
                    : typeof defaultCalendar !== 'undefined' ? defaultCalendar.summary : 'undefined',
            };
        this.setState({settingsCalendars: _calendars});
        this.setState({
            settingsDirty: true,
        });
    }

    onChangeCalendarDisplayName(column, calendarId, displayName) {

        // don't send a GA event because this gets called each key press

        let _calendars = JSON.parse(JSON.stringify(this.state.settingsCalendars));

        _calendars[column] =
            {
                calendarId: calendarId,
                column: column+1,
                displayName: displayName,
            };

        this.setState({settingsCalendars: _calendars});
        this.setState({
            settingsDirty: true,
        });
    }

    onDeleteCalendarColumn(column) {

        ReactGA.event({
            category: 'Settings',
            action: 'Remove',
            label: 'Calendar',
        });

        // remove the array element that matches the column being removed
        let _calendars = JSON.parse(JSON.stringify(this.state.settingsCalendars));
        for (let cal = 0; cal < _calendars.length; cal++) {
            if (_calendars[cal].column === column + 1) _calendars.splice(cal, 1);
        }

        // and re-balance the column numbers
        let _filtered = JSON.parse(JSON.stringify(_calendars));
        for (let cal = 0; cal < _filtered.length; cal++) {
            if (_filtered[cal].column > column + 1) _filtered[cal].column--;
        }

        this.setState({settingsCalendars: _filtered});
        this.setState({
            settingsDirty: true,
        });
    }

    onChangePreferences(preferencesValues) {
        this.setState({settingsIgnoreGoogleMeet: preferencesValues.indexOf(PREFERENCES_IGNORE_GOOGLE_MEET) !== -1});
        this.setState({settingsIgnoreZoomMeeting: preferencesValues.indexOf(PREFERENCES_IGNORE_ZOOM_MEETING) !== -1});
        this.setState({
            settingsDirty: true,
        });
    }

    render() {

        const {startDay} = this.state;
        const {calendars} = this.state;
        const {calendarDays} = this.state;
        const {observedDays} = this.state;
        const {events} = this.state;
        const {googleId} = this.state;
        const {anniversaries} = this.state;

        const userPreferences = {
            ignoreGoogleMeet: this.state.ignoreGoogleMeet,
            ignoreZoomMeeting: this.state.ignoreZoomMeeting,
        };

        return (
            <div className="flex-col flex-grow-1">
                { this.state.showWelcome &&
                <Welcome/>
                }
                {this.state.showCalendar && calendarDays && calendarDays.length > 0 &&
                <Table key="2"
                       myId={googleId}
                       startDay={startDay}
                       calendars={calendars}
                       events={events}
                       calendarDays={calendarDays}
                       observedDays={observedDays}
                       anniversaries={anniversaries}
                       onCalendarJump={this.handleClickCalendarJump}
                       createAppt={this.handleCreateAppt}
                       updateAppt={this.handleUpdateEvent}
                       deleteAppt={this.handleDeleteEvent}
                       unitTesting={this.props.unitTesting}
                       weather={this.state.weather}
                       preferences={userPreferences}
                />
                }
                <Settings isOpen={this.state.settingsModal}
                          toggle={this.onCancelSettings}
                          submit={this.onSubmitSettings}
                          dirty={this.state.settingsDirty}
                          accessibleCalendars={this.state.accessibleCalendars}
                          calendars={this.state.settingsCalendars}
                          observedCalendars={this.state.settingsObservedCalendars}
                          anniversaryCalendars={this.state.settingsAnniversaryCalendars}
                          onAddCalendar={this.onAddCalendarColumn}
                          onChangeCalendar={this.onChangeCalendar}
                          onChangeCalendarDisplayName={this.onChangeCalendarDisplayName}
                          onDeleteCalendar={this.onDeleteCalendarColumn}
                          onAddObservedCalendar={this.onAddObservedCalendar}
                          onChangeObservedCalendar={this.onChangeObservedCalendar}
                          onDeleteObservedCalendar={this.onDeleteObservedCalendar}
                          onAddAnniversaryCalendar={this.onAddAnniversaryCalendar}
                          onChangeAnniversaryCalendar={this.onChangeAnniversaryCalendar}
                          onDeleteAnniversaryCalendar={this.onDeleteAnniversaryCalendar}
                          preferencesData={[PREFERENCES_IGNORE_GOOGLE_MEET, PREFERENCES_IGNORE_ZOOM_MEETING]}
                          preferencesValues={[
                              this.state.settingsIgnoreGoogleMeet ? PREFERENCES_IGNORE_GOOGLE_MEET : '',
                              this.state.settingsIgnoreZoomMeeting ? PREFERENCES_IGNORE_ZOOM_MEETING : '',
                          ]}
                          onChangePreferences={this.onChangePreferences}
                />
                {this.state.signedIn &&
                    <div className="CalendarSignedInName">Signed in as {this.state.googleId}</div>
                }
                <div className="CalendarButtonToolbar">
                    <ButtonToolbar>
                        <Button size="sm" onClick={() => window.open('/help/docs/intro/')}>Help</Button>&nbsp;
                        {this.state.signedIn &&
                        <Button size="sm" onClick={() => this.onOpenSettings()}>Settings</Button>
                        }&nbsp;
                        {!this.state.signedIn &&
                        <Button size="sm" onClick={() => GoogleAuth.signIn()}>Sign In</Button>
                        }&nbsp;
                        {this.state.signedIn &&
                        <Button size="sm" onClick={() => GoogleAuth.signOut()}>Sign Out</Button>
                        }
                        &nbsp;<Button size="sm" onClick={() => window.open('/help/docs/privacy-policy/')}>Privacy</Button>&nbsp;
                    </ButtonToolbar>
                </div>
                <CalendarFooter unitTesting={this.props.unitTesting}/>
            </div>
        );
    }
}

export default FamilyCalendar;
